import dataApi from '../'

export default {

  /**
  * Get units based on a search value
  */
  getSearch (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/departments/search',
      params: params
    })
  },

  getDepartmentsForOrganizationAndItsAncestors (orgUuid) {
    return dataApi.request({
      method: 'get',
      url: 'ui/departments/org-and-ancestors/' + orgUuid
    })
  },

  /**
   * Get department
   */
  get (uuid) {
    return dataApi.request({
      method: 'get',
      url: 'ui/departments/' + uuid
    })
  },

  /**
   * Add department
   */
  create (body) {
    return dataApi.request({
      method: 'post',
      url: 'ui/departments',
      body: body
    })
  },

  /**
   * Edit department
   */
  update (uuid, body) {
    return dataApi.request({
      method: 'put',
      url: 'ui/departments/' + uuid,
      body: body
    })
  },

  /**
  * Delete department
  */
  deleteDelete (params) {
    return dataApi.request({
      method: 'delete',
      url: 'ui/departments/' + params.uuid
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/department.js